import { createRequest } from './createRequest'

export const notificationSettingGetPath = '/notification-setting/get'
export const notificationSettingGet = createRequest({ path: notificationSettingGetPath })

export const notificationSettingUpdatePath = '/notification-setting/update'
export const notificationSettingUpdate = createRequest({ path: notificationSettingUpdatePath })
